<script>
export default {
    props: ['authenticated', 'proommate', 'property_ad', 'location_object'],
    data() {
        return {
            roommate: this.proommate,
        }
    },
    computed: {
        fk_roommate() {
            return (this.roommate != false ? this.roommate.id : null);
        },
        contact_capability() {
            return (this.fk_roommate ? true : false);
        }
    },
    methods: {
        handle() {
            if (!this.canUserMessage())
                return;

            EventBus.$emit('open-modal', 'booking-modal', {
                fk_property_ad: this.property_ad.id
            });
        },
        canUserMessage() {
            if (!this.authenticated) {
                EventBus.$emit('open-modal', 'register-modal');
                window.dataLayer.push({
                    event: 'show_login_modal',
                    event_category: 'property_ad_page',
                    event_label: 'send_message'
                });
                return false;
            } else {
                if (!this.contact_capability) {
                    EventBus.$emit('open-modal', 'roommate-modal-form', {
                        backdrop: 'static',
                        location: this.location_object,
                        rent_price: this.property_ad.rent_price
                    });

                    window.dataLayer.push({
                        event: 'show_roommate_form',
                        event_category: 'property_ad_page',
                        event_label: 'send_message',
                    });
                    return false;
                }
            }
            return true;
        },
    },
    created() {
        EventBus.$on('roommate_ad_created', (res) => {
            this.roommate = res.roommate_ad
        });
    }
}
</script>
